import { toast } from 'sonner';
import type { ReactNode } from 'react';
import {
  createSuccessToast,
  createErrorToast,
  createInfoToast,
  createWarningToast,
} from '../components/ui/custom-toast';

export interface ToastOptions {
  description?: string;
  action?: ReactNode;
  duration?: number;
  id?: string;
}

export const enhancedToast = {
  success: (title: string, options?: ToastOptions) => {
    return toast.custom(() => createSuccessToast(title, options?.description, options?.action), {
      duration: options?.duration || 4000,
      id: options?.id,
    });
  },

  error: (title: string, options?: ToastOptions) => {
    return toast.custom(() => createErrorToast(title, options?.description, options?.action), {
      duration: options?.duration || 5000,
      id: options?.id,
    });
  },

  info: (title: string, options?: ToastOptions) => {
    return toast.custom(() => createInfoToast(title, options?.description, options?.action), {
      duration: options?.duration || 4000,
      id: options?.id,
    });
  },

  warning: (title: string, options?: ToastOptions) => {
    return toast.custom(() => createWarningToast(title, options?.description, options?.action), {
      duration: options?.duration || 4500,
      id: options?.id,
    });
  },
};

// Backward compatibility - these functions match the existing toast.success, toast.error pattern
export const toastSuccess = (title: string, options?: { description?: string }) => {
  return enhancedToast.success(title, options);
};

export const toastError = (title: string, options?: { description?: string }) => {
  return enhancedToast.error(title, options);
};

export const toastInfo = (title: string, options?: { description?: string }) => {
  return enhancedToast.info(title, options);
};

export const toastWarning = (title: string, options?: { description?: string }) => {
  return enhancedToast.warning(title, options);
};
